import { BlockStack, Card, Grid, InlineStack, ResourceItem, ResourceList, Select, Text, Thumbnail } from '@shopify/polaris';
import React, { useEffect, useState } from 'react'
import noImage from '../../../../../public/files/noImage.png';
import { DI, DIProps } from '../../../../Core';
import ReactJson from 'react-json-view';

interface props extends DIProps {
    previewModalData: any
    variantsArr: any
    getPreview: (val: string) => void
    selectedVariant: string
    setSelectedVariant: (val: string) => void
}

const TabularView = (props: props) => {
    const { previewModalData, variantsArr, getPreview, selectedVariant, setSelectedVariant } = props;
    const { mandatory_attr, optional_attr } = previewModalData;
    const [imageUrl, setImageUrl] = useState<any>([])
    const [general_attr, setGeneralAttr] = useState<any>([]);

    useEffect(() => {
        let tempArr: any = [];
        let tempGeneralAttr: any = {};
        const { mandatory_attr, optional_attr, offerId } = previewModalData;

        Object.keys(mandatory_attr)?.forEach((key: string) => {
            if (key?.includes('main_image_url')) {
                tempArr?.push(mandatory_attr?.[key]);
            }
            if (key?.includes('other_image_url')) {
                tempArr?.push(mandatory_attr?.[key]);
            }
        })

        Object.keys(mandatory_attr).forEach((key: string) => {
            if (!key.includes("main_image_url") && !key?.includes("other_image_url")) {
                tempGeneralAttr[key] = (mandatory_attr[key] === "" || mandatory_attr[key] === undefined || !mandatory_attr[key]) ? "N/A" : mandatory_attr[key]?.toString()
            }
        })
        if (tempArr?.length > 1) {
            // tempArr?.splice(0, 1);
            tempGeneralAttr['Images'] = tempArr
        }
        if (offerId) {
            setSelectedVariant(offerId)
        }
        tempArr.uniqueArray()
        setImageUrl([...tempArr]);
        setGeneralAttr({ ...tempGeneralAttr });
    }, [previewModalData])



    return (
        <BlockStack gap='500'>
            <Grid>
                <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 6, lg: 8, xl: 8 }}>
                    <InlineStack wrap={false} blockAlign='center' gap="400">
                        <Thumbnail size='small' source={imageUrl[0] || noImage} alt="Black choker necklace" />
                        <Text variant="headingMd" as="h6" fontWeight="medium" >{mandatory_attr?.item_name || mandatory_attr['Item Name (aka Title) (item_name)'] || ""}</Text>
                    </InlineStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 6, lg: 4, xl: 4 }}>

                    {
                        variantsArr?.length > 0 &&
                        <Select
                            labelHidden
                            label='Select Variant'
                            options={[...variantsArr]}
                            placeholder='Select Variant'
                            value={selectedVariant}
                            onChange={(val: string) => {
                                setSelectedVariant(val)
                                getPreview(val)
                            }}
                        />
                    }
                </Grid.Cell>
            </Grid>
            {/* GENERAL ATTRIBUTES */}
            {/* <Text variant="headingSm" as="h6" fontWeight="medium">General</Text>
            <Card padding="0">
                <div className='custom_tabularview--list'>
                    <ResourceList
                        resourceName={{ singular: 'customer', plural: 'customers' }}
                        items={Object.entries(general_attr).map(([key, value]: any) => ({ name: key, value: value }))}
                        renderItem={(item) => {
                            return (
                                <ResourceItem id={item.name} onClick={() => { }}>
                                    <Grid>
                                        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 6, lg: 4, xl: 4 }}>
                                            <Text variant="headingSm" as="h6" fontWeight="medium" tone='subdued'>{item.name?.toString() === 'Images' ? 'Aditional Images' : item.name?.toString()}</Text>
                                        </Grid.Cell>
                                        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 6, lg: 8, xl: 8 }}>
                                            {
                                                item.name === 'Images' ?
                                                    <InlineStack gap='200' wrap>
                                                        {item.value?.filter((img: string) => img !== imageUrl?.[0])?.map((img: any) => <Thumbnail size='small' source={img || noImage} alt="Black choker necklace" />)}
                                                    </InlineStack>
                                                    :
                                                    <Text variant="headingSm" as="h6" fontWeight="medium">{item.value}</Text>
                                            }
                                        </Grid.Cell>
                                    </Grid>
                                </ResourceItem>
                            );
                        }}
                    />
                </div>
            </Card> */}

            {/* OPTIONAL ATTRIBUTES */}
            <ReactJson theme={"monokai"} enableClipboard={false} displayDataTypes={false} src={{ ...previewModalData?.mandatory_attr, ...previewModalData?.optional_attr }} ></ReactJson>
            {/* <Text variant="headingSm" as="h6" fontWeight="medium" >Attributes</Text>
            <Card padding="0">
                <div className='custom_tabularview--list'>
                    <ResourceList
                        resourceName={{ singular: 'customer', plural: 'customers' }}
                        items={Object.entries(optional_attr).map(([key, value]: any) => ({ name: key, value: value }))}
                        renderItem={
                            (item) => {
                            return (
                                <ResourceItem id={item.name} onClick={() => { }}>
                                    <Grid>
                                        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 6, lg: 4, xl: 4 }}>
                                            <Text variant="headingSm" as="h6" fontWeight="medium" tone='subdued'>{item.name}</Text>
                                        </Grid.Cell>
                                        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 6, lg: 8, xl: 8 }}>
                                            <Text variant="headingSm" as="h6" fontWeight="medium">
                                                {(item.value === "" || item.value === undefined || !item.value) ? "N/A" : returnAttributeValue(item)?.toString()??"N/A"}
                                            </Text>
                                        </Grid.Cell>
                                    </Grid>
                                </ResourceItem>
                            );
                        }
                    }
                    />
                </div>
            </Card> */}
        </BlockStack>
    )
}

export default DI(TabularView)